import React from 'react';
import '../../../../style/CompanyFormTabs.css';

const CompanyFormActions = ({ 
  activeTab, 
  setActiveTab, 
  formData, 
  setFormData, 
  errors, 
  setErrors, 
  tabValidation, 
  setTabValidation, 
  logoPreview, 
  setLogoPreview, 
  tabs,
  isEditMode, 
  handleSubmit,
  isSubmitting,
  validateForm
}) => {
  
  // Validate current tab
  const validateCurrentTab = () => {
    const newErrors = {};
    
    switch (activeTab) {
      case 0: // Basic Information
        if (!formData.companyName.trim()) {
          newErrors.companyName = 'Company name is required';
        }
        // Make website required
        if (!formData.companyWebsite.trim()) {
          newErrors.companyWebsite = 'Company website is required';
        } else if (!/^https?:\/\/.+/.test(formData.companyWebsite)) {
          newErrors.companyWebsite = 'Please enter a valid website URL (include http:// or https://)';
        }
        if (!formData.organisationSize) {
          newErrors.organisationSize = 'Organization size is required';
        }
        if (!formData.industry_id) {
          newErrors.industry_id = 'Industry is required';
        }
        if (!formData.aboutUs.trim()) {
          newErrors.aboutUs = 'About company is required';
        }
        break;
        
      case 1: // Address
        if (!formData.address1.trim()) {
          newErrors.address1 = 'Address line 1 is required';
        }
        if (!formData.state) {
          newErrors.state = 'State is required';
        }
        if (!formData.city) {
          newErrors.city = 'City is required';
        }
        break;
        
      case 2: // Contact Person
        if (!formData.contactPersonName.trim()) {
          newErrors.contactPersonName = 'Contact person name is required';
        }
        if (!formData.contactPersonNumber.trim()) {
          newErrors.contactPersonNumber = 'Contact person number is required';
        } else if (!/^\d{10}$/.test(formData.contactPersonNumber)) {
          newErrors.contactPersonNumber = 'Contact number must be 10 digits';
        }
        if (!formData.contactPersonEmail.trim()) {
          newErrors.contactPersonEmail = 'Contact person email is required';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.contactPersonEmail)) {
          newErrors.contactPersonEmail = 'Please enter a valid email address';
        }
        break;
        
      default:
        break;
    }
    
    setErrors(prev => ({ ...prev, ...newErrors }));
    
    // Update tab validation status
    const isValid = Object.keys(newErrors).length === 0;
    setTabValidation(prev => ({ ...prev, [activeTab]: isValid }));
    
    return isValid;
  };

  // Handle next tab
  const handleNext = () => {
    if (validateCurrentTab()) {
      setActiveTab(activeTab + 1);
    }
  };

  // Handle previous tab
  const handlePrevious = () => {
    setActiveTab(activeTab - 1);
  };

  // Handle form submission
  const handleFormSubmit = async () => {
    if (validateForm()) {
      await handleSubmit();
    }
  };

  return (
    <div className="company-form-actions">
      <div className="row">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center">
            {/* Previous Button */}
            <div>
              {activeTab > 0 && (
                <button
                  type="button"
                  className="action-btn btn btn-outline-primary me-2"
                  onClick={handlePrevious}
                  disabled={isSubmitting}
                >
                  <i className="bi bi-chevron-left me-1"></i>
                  Previous
                </button>
              )}
            </div>

            {/* Next/Submit Button */}
            <div>
              {activeTab < tabs.length - 1 ? (
                <button
                  type="button"
                  className="action-btn btn btn-primary"
                  onClick={handleNext}
                  disabled={isSubmitting}
                >
                  Next
                  <i className="bi bi-chevron-right ms-1"></i>
                </button>
              ) : (
                <button
                  type="button"
                  className="action-btn btn btn-success"
                  onClick={handleFormSubmit}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      {isEditMode ? 'Updating...' : 'Creating...'}
                    </>
                  ) : (
                    <>
                      <i className="bi bi-check me-1"></i>
                      {isEditMode ? 'Update Organization' : 'Create Organization'}
                    </>
                  )}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyFormActions;